import api from "../../Http/global-vars";
import { FETCH_CATALOGUES, CHEARCH_UNIVERSITY } from "../types";

export const fetchCatalogue = () => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "university/";
    await fetch(url, config)
      .then(async (res) => {
        const data = await res.json();
        // console.log("data categories", data);
        dispatch({
          type: FETCH_CATALOGUES,
          payload: data.results.sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};

export const searchUniversity = (universities, searchItem, pays) => {
  // posts.filter((x) => console.log("object", x.category.indexOf(2)));

  let data = [];
  // eslint-disable-next-line
  if (searchItem && pays) {
    data = universities?.filter(
      (user) =>
        user?.nom?.toLowerCase()?.includes(searchItem) && user?.pays === pays
    );
  } else if (!searchItem && pays) {
    data = universities?.filter((user) => user?.pays === pays);
  } else if (searchItem && !pays) {
    data = universities?.filter((user) =>
      user?.nom?.toLowerCase()?.includes(searchItem)
    );
  }
  //   console.log("voir", searchItem, data);
  // return "";
  return (dispatch) => {
    dispatch({
      type: CHEARCH_UNIVERSITY,
      payload: {
        items:
          !searchItem?.length && !pays
            ? universities?.sort((a, b) => b?.id - a?.id)
            : data?.sort((a, b) => b?.id - a?.id),
      },
    });
  };
};
